import { useState, useEffect } from 'react';
import { Box, Grid, Divider } from '@mui/material';
import BookingCalendar from './BookingCalendar';
import BookingSchedule from './BookingSchedule';
import { getBookedSlots } from '../../actions/bookings';

const BookingDateTime = ({
  selectedDate, onDateSelect,
  selectedTime, onTimeSelect,
  service, error = false
}) => {
  const [bookedSlots, setBookedSlots] = useState([]);

  useEffect(() => {
    if (!selectedDate || !service?._id) return;

    const fecha = selectedDate.toISOString().split('T')[0]; // "YYYY-MM-DD"
    getBookedSlots(service._id, fecha).then(setBookedSlots);

    // Reset time selection when date changes
    onTimeSelect(null);
  }, [selectedDate, service?._id]);

  return (
    <Box sx={{
      p: 4,
      borderRadius: '24px',
      bgcolor: 'white',
      border: '1px solid',
      borderColor: error ? 'error.main' : '#F1F5F9',
      transition: 'border-color 0.2s'
    }}>
      <Grid container spacing={4}>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <BookingCalendar
            selectedDate={selectedDate}
            onDateSelect={onDateSelect}
            hideContainer={true}
            disponibilidad={service?.disponibilidad}
          />
        </Grid>

        <Grid item size="auto" sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Divider orientation="vertical" sx={{ height: '100%', borderColor: '#F1F5F9' }} />
        </Grid>

        <Grid item size={{ xs: 12, sm: 'grow' }}>
          <BookingSchedule
            selectedTime={selectedTime}
            onTimeSelect={onTimeSelect}
            hideContainer={true}
            service={service}
            selectedDate={selectedDate}
            bookedSlots={bookedSlots}
            error={error}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BookingDateTime;
